import { CheckedAnswerCorrectOnlySvg } from "../../svg/index";

const SVGCheckedAnswerCorrectOnly = ({ value = "correct", width = 15, height = 40 }) => {
	let jsx;
	const props = { width, height };
	if ( value === "correct" ) {
		jsx = <CheckedAnswerCorrectOnlySvg {...props} />;
	} else {
		jsx = <></>;
	}
	return jsx;
};

export default SVGCheckedAnswerCorrectOnly;
